import { Reducer } from "redux";

import { AirlineProductivityAction, AirlinesProductivityActionTypes, AirlinesProductivityState } from "./types";

const initialState: AirlinesProductivityState = {
  count: 0,
  items: [],
  isLoading: false,
  dailyItems: {},
};

const reducer: Reducer<AirlinesProductivityState, AirlineProductivityAction> = (state = initialState, action) => {
  switch (action.type) {
    case AirlinesProductivityActionTypes.TABLE_FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }

    case AirlinesProductivityActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, items: results, dailyItems: {}, isLoading: false };
    }

    case AirlinesProductivityActionTypes.DAILY_FETCH_SUCCESS: {
      const { airline, items } = action.payload;
      return { ...state, dailyItems: { ...state.dailyItems, [airline]: items } };
    }

    case AirlinesProductivityActionTypes.DAILY_FETCH_ERROR:
    case AirlinesProductivityActionTypes.TABLE_FETCH_ERROR:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};

export default reducer;
